import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimerDark() {
  const [time, setTime] = useState(14 * 60 + 59); // 14:59
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  if (time === 0) return null;
  return <div className="fixed top-0 left-0 w-full bg-orange-500 text-white z-50 py-3 px-4 shadow-lg" data-id="element-6">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 font-bold text-sm md:text-base" data-id="element-7">
        <Clock className="w-5 h-5 animate-pulse" data-id="element-8" />
        <span className="uppercase tracking-wide" data-id="element-9">
          Esta oferta termina pronto:
        </span>
        <span className="bg-slate-900 text-orange-300 px-3 py-1 rounded-lg font-mono text-lg tracking-wider" data-id="element-10">
          {formatTime(time)}
        </span>
      </div>
    </div>;
}